import React, { createContext, useContext, useMemo, useState } from 'react'
import { getPedidos, getDadosPedido } from '../api/pedidos.servico'
import { useGlobal } from '../contexts/GlobalContext'
import { isEmptyObject } from '../utils/helpers/helpers'

const MeusKitsContext = createContext()

function MeusKitsProvider( props ) {
  const [ state, setState ] = useState( {
    'dadosMeusKits': [],
    'detalhePedido': {},
    'loadingRequisicaoMeusKits': true
  } )

  const value = useMemo( () => {
    return {
      setState,
      state
    }
  }, [ state ] )

  return (
    <MeusKitsContext.Provider
      value={ value }
      { ...props }
    />
  )
}

function useMeusKits() {
  const context = useContext( MeusKitsContext )
  if ( !context ) {
    throw new Error( 'useMeusKits deve ser usado dentro de um MeusKitsProvider' )
  }

  const { state, setState } = context
  const { setErroRequisicao } = useGlobal()

  const setLoadingRequisicaoMeusKits = loading => {
    setState( prevState => ( {
      ...prevState,
      'loadingRequisicaoMeusKits': loading
    } ) )
  }

  const setDadosMeusKits = pedidos => {
    setState( prevState => ( {
      ...prevState,
      'dadosMeusKits': pedidos
    } ) )
  }

  const setDetalhePedido = detalhePedido => {
    setState( prevState => ( {
      ...prevState,
      detalhePedido
    } ) )
  }

  const listarPedidos = async() => {
    try {
      const { 'data': dados } = await getPedidos()
      if ( !isEmptyObject( dados ) ) {
        setDadosMeusKits( dados )
      }
    } catch ( erro ) {
      setErroRequisicao( erro.response.status )
    }
  }

  const buscarDadosPedido = async( idPedido ) => {
    try {
      const { 'data': dados } = await getDadosPedido( idPedido )
      if ( !isEmptyObject( dados ) ) {
        setDetalhePedido( dados )
      }
    } catch ( erro ) {
      setErroRequisicao( erro.response.status )
    }
  }

  return {
    buscarDadosPedido,
    'dadosMeusKits': state.dadosMeusKits,
    'detalhePedido': state.detalhePedido,
    listarPedidos,
    'loadingRequisicaoMeusKits': state.loadingRequisicaoMeusKits,
    setLoadingRequisicaoMeusKits
  }
}

export { MeusKitsProvider, useMeusKits }
